export default {
  GET_ALL_GENDERS (state, data) {
    state.all_genders = data.data
  }
}
